import { CommonModule } from '@angular/common';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { SedsHeaderComponent } from './seds-header.component';
import { SedsHeaderLogoModule } from './seds-header-logo/seds-header-logo.module';
import { SedsHeaderMenuModule } from './seds-header-menu/seds-header-menu.module';
import { SedsHeaderUserModule } from './seds-header-user/seds-header-user.module';
import { SedsBadgeModule } from '../seds-badge/seds-badge.module';
import { SedsTimerModule } from '../seds-timer/seds-timer.module';

@NgModule({
  declarations: [SedsHeaderComponent],
  imports: [
    CommonModule,
    SedsHeaderLogoModule,
    SedsBadgeModule,
    SedsHeaderMenuModule,
    SedsHeaderUserModule,
    SedsTimerModule,
  ],
  exports: [SedsHeaderComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SedsHeaderModule {}
